export default "__VITE_ASSET__Cdi96gGE__"